export const SET_API = 'SET_API';

export const setApi = (value: any) => ({
  type: SET_API,
  value,
});
